module.exports = __webpack_public_path__ + "img/bg.be5a3fec.png";